// extracted by mini-css-extract-plugin
export var button = "_ji-2";
export var card = "_ji-0";
export var closeButtonContainer = "_ji-3";
export var iconContainer = "_ji-1";